import React from 'react';

export const DRIVER_STATUS_OPTIONS = [
  { value: 'Operativo', tone: 'operativo', label: 'Operativo' },
  { value: 'Descanso', tone: 'descanso', label: 'Descanso' },
  { value: 'Con licencia', tone: 'licencia', label: 'Con licencia' },
  { value: 'En servicio', tone: 'servicio', label: 'En servicio' },
] as const;

type Props = {
  value: string;
  onChange: (status: string) => void;
  disabled?: boolean;
};

const DriverStatusSelector: React.FC<Props> = ({ value, onChange, disabled = false }) => {
  return (
    <div className="ed-driver__status-selector" role="group" aria-label="Estado del conductor">
      <span className="ed-driver__status-selector-label">Estado</span>
      <div className="ed-driver__status-options">
        {DRIVER_STATUS_OPTIONS.map((option) => {
          const isActive = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              className={`ed-driver__status-chip ed-driver__status-chip--${option.tone}${
                isActive ? ' is-active' : ''
              }`}
              onClick={() => onChange(option.value)}
              disabled={disabled}
              aria-pressed={isActive}
            >
              {isActive && <span className="ed-driver__status-chip-dot" aria-hidden />}
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DriverStatusSelector;
